/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createServerRootRoute } from '@tanstack/react-start/server'

import { Route as rootRouteImport } from './routes/__root'
import { Route as HomeRouteImport } from './routes/_home'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as RegisterIndexRouteImport } from './routes/register/index'
import { Route as NewsletterIndexRouteImport } from './routes/newsletter/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as ForgotPasswordIndexRouteImport } from './routes/forgotPassword/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as HomeIndexRouteImport } from './routes/_home/index'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardRoutinesRouteImport } from './routes/dashboard/routines'
import { Route as DashboardProfileRouteImport } from './routes/dashboard/profile'
import { Route as DashboardNotificationSettingsRouteImport } from './routes/dashboard/notificationSettings'
import { Route as DashboardNewUserRouteImport } from './routes/dashboard/newUser'
import { Route as DashboardHealthAreasRouteImport } from './routes/dashboard/health-areas'
import { Route as DashboardGoalsRouteImport } from './routes/dashboard/goals'
import { Route as DashboardCalendarSettingsRouteImport } from './routes/dashboard/calendarSettings'
import { Route as DashboardCalendarRouteImport } from './routes/dashboard/calendar'
import { Route as DashboardAccountRouteImport } from './routes/dashboard/account'
import { Route as HomeUnsubscribeRouteImport } from './routes/_home/unsubscribe'
import { Route as HomeToolsRouteImport } from './routes/_home/tools'
import { Route as HomeTermsOfServiceRouteImport } from './routes/_home/termsOfService'
import { Route as HomeResetPasswordRouteImport } from './routes/_home/resetPassword'
import { Route as HomePrivacyPolicyRouteImport } from './routes/_home/privacyPolicy'
import { Route as HomePricingRouteImport } from './routes/_home/pricing'
import { Route as HomeContactRouteImport } from './routes/_home/contact'
import { Route as HomeCompareRouteImport } from './routes/_home/compare'
import { Route as HomeColorsRouteImport } from './routes/_home/colors'
import { Route as HomeChangelogRouteImport } from './routes/_home/changelog'
import { Route as HomeAuthErrorRouteImport } from './routes/_home/authError'
import { Route as HomeAffiliateRouteImport } from './routes/_home/affiliate'
import { Route as HomeAboutUsRouteImport } from './routes/_home/aboutUs'
import { Route as DashboardLibraryIndexRouteImport } from './routes/dashboard/library/index'
import { Route as HomeBlogIndexRouteImport } from './routes/_home/blog/index'
import { Route as DashboardRoutineManageRouteImport } from './routes/dashboard/routine/manage'
import { Route as DashboardHealthAreaManageRouteImport } from './routes/dashboard/health-area/manage'
import { Route as DashboardGoalManageRouteImport } from './routes/dashboard/goal/manage'
import { Route as DashboardHealthAreaIdIndexRouteImport } from './routes/dashboard/health-area/$id/index'
import { Route as DashboardGoalIdIndexRouteImport } from './routes/dashboard/goal/$id/index'
import { Route as HomeBlogSlugIndexRouteImport } from './routes/_home/blog/$slug/index'
import { Route as DashboardLibraryHealthAreaSlugIndexRouteImport } from './routes/dashboard/library/health-area/$slug/index'
import { Route as HomeBlogPagePageNumberIndexRouteImport } from './routes/_home/blog/page/$pageNumber/index'
import { ServerRoute as ApiHealthServerRouteImport } from './routes/api/health'
import { ServerRoute as ApiAndroidRtdnWebhookServerRouteImport } from './routes/api/android-rtdn-webhook'
import { ServerRoute as ApiAuthSplatServerRouteImport } from './routes/api/auth/$'

const rootServerRouteImport = createServerRootRoute()

const HomeRoute = HomeRouteImport.update({
  id: '/_home',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterIndexRoute = RegisterIndexRouteImport.update({
  id: '/register/',
  path: '/register/',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsletterIndexRoute = NewsletterIndexRouteImport.update({
  id: '/newsletter/',
  path: '/newsletter/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordIndexRoute = ForgotPasswordIndexRouteImport.update({
  id: '/forgotPassword/',
  path: '/forgotPassword/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HomeRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardRoutinesRoute = DashboardRoutinesRouteImport.update({
  id: '/routines',
  path: '/routines',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardProfileRoute = DashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardNotificationSettingsRoute =
  DashboardNotificationSettingsRouteImport.update({
    id: '/notificationSettings',
    path: '/notificationSettings',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardNewUserRoute = DashboardNewUserRouteImport.update({
  id: '/newUser',
  path: '/newUser',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardHealthAreasRoute = DashboardHealthAreasRouteImport.update({
  id: '/health-areas',
  path: '/health-areas',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardGoalsRoute = DashboardGoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCalendarSettingsRoute =
  DashboardCalendarSettingsRouteImport.update({
    id: '/calendarSettings',
    path: '/calendarSettings',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCalendarRoute = DashboardCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAccountRoute = DashboardAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const HomeUnsubscribeRoute = HomeUnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => HomeRoute,
} as any)
const HomeToolsRoute = HomeToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => HomeRoute,
} as any)
const HomeTermsOfServiceRoute = HomeTermsOfServiceRouteImport.update({
  id: '/termsOfService',
  path: '/termsOfService',
  getParentRoute: () => HomeRoute,
} as any)
const HomeResetPasswordRoute = HomeResetPasswordRouteImport.update({
  id: '/resetPassword',
  path: '/resetPassword',
  getParentRoute: () => HomeRoute,
} as any)
const HomePrivacyPolicyRoute = HomePrivacyPolicyRouteImport.update({
  id: '/privacyPolicy',
  path: '/privacyPolicy',
  getParentRoute: () => HomeRoute,
} as any)
const HomePricingRoute = HomePricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => HomeRoute,
} as any)
const HomeContactRoute = HomeContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => HomeRoute,
} as any)
const HomeCompareRoute = HomeCompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => HomeRoute,
} as any)
const HomeColorsRoute = HomeColorsRouteImport.update({
  id: '/colors',
  path: '/colors',
  getParentRoute: () => HomeRoute,
} as any)
const HomeChangelogRoute = HomeChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => HomeRoute,
} as any)
const HomeAuthErrorRoute = HomeAuthErrorRouteImport.update({
  id: '/authError',
  path: '/authError',
  getParentRoute: () => HomeRoute,
} as any)
const HomeAffiliateRoute = HomeAffiliateRouteImport.update({
  id: '/affiliate',
  path: '/affiliate',
  getParentRoute: () => HomeRoute,
} as any)
const HomeAboutUsRoute = HomeAboutUsRouteImport.update({
  id: '/aboutUs',
  path: '/aboutUs',
  getParentRoute: () => HomeRoute,
} as any)
const DashboardLibraryIndexRoute = DashboardLibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const HomeBlogIndexRoute = HomeBlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => HomeRoute,
} as any)
const DashboardRoutineManageRoute = DashboardRoutineManageRouteImport.update({
  id: '/routine/manage',
  path: '/routine/manage',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardHealthAreaManageRoute =
  DashboardHealthAreaManageRouteImport.update({
    id: '/health-area/manage',
    path: '/health-area/manage',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardGoalManageRoute = DashboardGoalManageRouteImport.update({
  id: '/goal/manage',
  path: '/goal/manage',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardHealthAreaIdIndexRoute =
  DashboardHealthAreaIdIndexRouteImport.update({
    id: '/health-area/$id/',
    path: '/health-area/$id/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardGoalIdIndexRoute = DashboardGoalIdIndexRouteImport.update({
  id: '/goal/$id/',
  path: '/goal/$id/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const HomeBlogSlugIndexRoute = HomeBlogSlugIndexRouteImport.update({
  id: '/blog/$slug/',
  path: '/blog/$slug/',
  getParentRoute: () => HomeRoute,
} as any)
const DashboardLibraryHealthAreaSlugIndexRoute =
  DashboardLibraryHealthAreaSlugIndexRouteImport.update({
    id: '/library/health-area/$slug/',
    path: '/library/health-area/$slug/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const HomeBlogPagePageNumberIndexRoute =
  HomeBlogPagePageNumberIndexRouteImport.update({
    id: '/blog/page/$pageNumber/',
    path: '/blog/page/$pageNumber/',
    getParentRoute: () => HomeRoute,
  } as any)
const ApiHealthServerRoute = ApiHealthServerRouteImport.update({
  id: '/api/health',
  path: '/api/health',
  getParentRoute: () => rootServerRouteImport,
} as any)
const ApiAndroidRtdnWebhookServerRoute =
  ApiAndroidRtdnWebhookServerRouteImport.update({
    id: '/api/android-rtdn-webhook',
    path: '/api/android-rtdn-webhook',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiAuthSplatServerRoute = ApiAuthSplatServerRouteImport.update({
  id: '/api/auth/$',
  path: '/api/auth/$',
  getParentRoute: () => rootServerRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/aboutUs': typeof HomeAboutUsRoute
  '/affiliate': typeof HomeAffiliateRoute
  '/authError': typeof HomeAuthErrorRoute
  '/changelog': typeof HomeChangelogRoute
  '/colors': typeof HomeColorsRoute
  '/compare': typeof HomeCompareRoute
  '/contact': typeof HomeContactRoute
  '/pricing': typeof HomePricingRoute
  '/privacyPolicy': typeof HomePrivacyPolicyRoute
  '/resetPassword': typeof HomeResetPasswordRoute
  '/termsOfService': typeof HomeTermsOfServiceRoute
  '/tools': typeof HomeToolsRoute
  '/unsubscribe': typeof HomeUnsubscribeRoute
  '/dashboard/account': typeof DashboardAccountRoute
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/calendarSettings': typeof DashboardCalendarSettingsRoute
  '/dashboard/goals': typeof DashboardGoalsRoute
  '/dashboard/health-areas': typeof DashboardHealthAreasRoute
  '/dashboard/newUser': typeof DashboardNewUserRoute
  '/dashboard/notificationSettings': typeof DashboardNotificationSettingsRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/routines': typeof DashboardRoutinesRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/': typeof HomeIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/forgotPassword': typeof ForgotPasswordIndexRoute
  '/login': typeof LoginIndexRoute
  '/newsletter': typeof NewsletterIndexRoute
  '/register': typeof RegisterIndexRoute
  '/dashboard/goal/manage': typeof DashboardGoalManageRoute
  '/dashboard/health-area/manage': typeof DashboardHealthAreaManageRoute
  '/dashboard/routine/manage': typeof DashboardRoutineManageRoute
  '/blog': typeof HomeBlogIndexRoute
  '/dashboard/library': typeof DashboardLibraryIndexRoute
  '/blog/$slug': typeof HomeBlogSlugIndexRoute
  '/dashboard/goal/$id': typeof DashboardGoalIdIndexRoute
  '/dashboard/health-area/$id': typeof DashboardHealthAreaIdIndexRoute
  '/blog/page/$pageNumber': typeof HomeBlogPagePageNumberIndexRoute
  '/dashboard/library/health-area/$slug': typeof DashboardLibraryHealthAreaSlugIndexRoute
}
export interface FileRoutesByTo {
  '/aboutUs': typeof HomeAboutUsRoute
  '/affiliate': typeof HomeAffiliateRoute
  '/authError': typeof HomeAuthErrorRoute
  '/changelog': typeof HomeChangelogRoute
  '/colors': typeof HomeColorsRoute
  '/compare': typeof HomeCompareRoute
  '/contact': typeof HomeContactRoute
  '/pricing': typeof HomePricingRoute
  '/privacyPolicy': typeof HomePrivacyPolicyRoute
  '/resetPassword': typeof HomeResetPasswordRoute
  '/termsOfService': typeof HomeTermsOfServiceRoute
  '/tools': typeof HomeToolsRoute
  '/unsubscribe': typeof HomeUnsubscribeRoute
  '/dashboard/account': typeof DashboardAccountRoute
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/calendarSettings': typeof DashboardCalendarSettingsRoute
  '/dashboard/goals': typeof DashboardGoalsRoute
  '/dashboard/health-areas': typeof DashboardHealthAreasRoute
  '/dashboard/newUser': typeof DashboardNewUserRoute
  '/dashboard/notificationSettings': typeof DashboardNotificationSettingsRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/routines': typeof DashboardRoutinesRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/': typeof HomeIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/forgotPassword': typeof ForgotPasswordIndexRoute
  '/login': typeof LoginIndexRoute
  '/newsletter': typeof NewsletterIndexRoute
  '/register': typeof RegisterIndexRoute
  '/dashboard/goal/manage': typeof DashboardGoalManageRoute
  '/dashboard/health-area/manage': typeof DashboardHealthAreaManageRoute
  '/dashboard/routine/manage': typeof DashboardRoutineManageRoute
  '/blog': typeof HomeBlogIndexRoute
  '/dashboard/library': typeof DashboardLibraryIndexRoute
  '/blog/$slug': typeof HomeBlogSlugIndexRoute
  '/dashboard/goal/$id': typeof DashboardGoalIdIndexRoute
  '/dashboard/health-area/$id': typeof DashboardHealthAreaIdIndexRoute
  '/blog/page/$pageNumber': typeof HomeBlogPagePageNumberIndexRoute
  '/dashboard/library/health-area/$slug': typeof DashboardLibraryHealthAreaSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/_home': typeof HomeRouteWithChildren
  '/_home/aboutUs': typeof HomeAboutUsRoute
  '/_home/affiliate': typeof HomeAffiliateRoute
  '/_home/authError': typeof HomeAuthErrorRoute
  '/_home/changelog': typeof HomeChangelogRoute
  '/_home/colors': typeof HomeColorsRoute
  '/_home/compare': typeof HomeCompareRoute
  '/_home/contact': typeof HomeContactRoute
  '/_home/pricing': typeof HomePricingRoute
  '/_home/privacyPolicy': typeof HomePrivacyPolicyRoute
  '/_home/resetPassword': typeof HomeResetPasswordRoute
  '/_home/termsOfService': typeof HomeTermsOfServiceRoute
  '/_home/tools': typeof HomeToolsRoute
  '/_home/unsubscribe': typeof HomeUnsubscribeRoute
  '/dashboard/account': typeof DashboardAccountRoute
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/calendarSettings': typeof DashboardCalendarSettingsRoute
  '/dashboard/goals': typeof DashboardGoalsRoute
  '/dashboard/health-areas': typeof DashboardHealthAreasRoute
  '/dashboard/newUser': typeof DashboardNewUserRoute
  '/dashboard/notificationSettings': typeof DashboardNotificationSettingsRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/routines': typeof DashboardRoutinesRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/_home/': typeof HomeIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/forgotPassword/': typeof ForgotPasswordIndexRoute
  '/login/': typeof LoginIndexRoute
  '/newsletter/': typeof NewsletterIndexRoute
  '/register/': typeof RegisterIndexRoute
  '/dashboard/goal/manage': typeof DashboardGoalManageRoute
  '/dashboard/health-area/manage': typeof DashboardHealthAreaManageRoute
  '/dashboard/routine/manage': typeof DashboardRoutineManageRoute
  '/_home/blog/': typeof HomeBlogIndexRoute
  '/dashboard/library/': typeof DashboardLibraryIndexRoute
  '/_home/blog/$slug/': typeof HomeBlogSlugIndexRoute
  '/dashboard/goal/$id/': typeof DashboardGoalIdIndexRoute
  '/dashboard/health-area/$id/': typeof DashboardHealthAreaIdIndexRoute
  '/_home/blog/page/$pageNumber/': typeof HomeBlogPagePageNumberIndexRoute
  '/dashboard/library/health-area/$slug/': typeof DashboardLibraryHealthAreaSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/dashboard'
    | '/aboutUs'
    | '/affiliate'
    | '/authError'
    | '/changelog'
    | '/colors'
    | '/compare'
    | '/contact'
    | '/pricing'
    | '/privacyPolicy'
    | '/resetPassword'
    | '/termsOfService'
    | '/tools'
    | '/unsubscribe'
    | '/dashboard/account'
    | '/dashboard/calendar'
    | '/dashboard/calendarSettings'
    | '/dashboard/goals'
    | '/dashboard/health-areas'
    | '/dashboard/newUser'
    | '/dashboard/notificationSettings'
    | '/dashboard/profile'
    | '/dashboard/routines'
    | '/dashboard/settings'
    | '/'
    | '/dashboard/'
    | '/forgotPassword'
    | '/login'
    | '/newsletter'
    | '/register'
    | '/dashboard/goal/manage'
    | '/dashboard/health-area/manage'
    | '/dashboard/routine/manage'
    | '/blog'
    | '/dashboard/library'
    | '/blog/$slug'
    | '/dashboard/goal/$id'
    | '/dashboard/health-area/$id'
    | '/blog/page/$pageNumber'
    | '/dashboard/library/health-area/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/aboutUs'
    | '/affiliate'
    | '/authError'
    | '/changelog'
    | '/colors'
    | '/compare'
    | '/contact'
    | '/pricing'
    | '/privacyPolicy'
    | '/resetPassword'
    | '/termsOfService'
    | '/tools'
    | '/unsubscribe'
    | '/dashboard/account'
    | '/dashboard/calendar'
    | '/dashboard/calendarSettings'
    | '/dashboard/goals'
    | '/dashboard/health-areas'
    | '/dashboard/newUser'
    | '/dashboard/notificationSettings'
    | '/dashboard/profile'
    | '/dashboard/routines'
    | '/dashboard/settings'
    | '/'
    | '/dashboard'
    | '/forgotPassword'
    | '/login'
    | '/newsletter'
    | '/register'
    | '/dashboard/goal/manage'
    | '/dashboard/health-area/manage'
    | '/dashboard/routine/manage'
    | '/blog'
    | '/dashboard/library'
    | '/blog/$slug'
    | '/dashboard/goal/$id'
    | '/dashboard/health-area/$id'
    | '/blog/page/$pageNumber'
    | '/dashboard/library/health-area/$slug'
  id:
    | '__root__'
    | '/dashboard'
    | '/_home'
    | '/_home/aboutUs'
    | '/_home/affiliate'
    | '/_home/authError'
    | '/_home/changelog'
    | '/_home/colors'
    | '/_home/compare'
    | '/_home/contact'
    | '/_home/pricing'
    | '/_home/privacyPolicy'
    | '/_home/resetPassword'
    | '/_home/termsOfService'
    | '/_home/tools'
    | '/_home/unsubscribe'
    | '/dashboard/account'
    | '/dashboard/calendar'
    | '/dashboard/calendarSettings'
    | '/dashboard/goals'
    | '/dashboard/health-areas'
    | '/dashboard/newUser'
    | '/dashboard/notificationSettings'
    | '/dashboard/profile'
    | '/dashboard/routines'
    | '/dashboard/settings'
    | '/_home/'
    | '/dashboard/'
    | '/forgotPassword/'
    | '/login/'
    | '/newsletter/'
    | '/register/'
    | '/dashboard/goal/manage'
    | '/dashboard/health-area/manage'
    | '/dashboard/routine/manage'
    | '/_home/blog/'
    | '/dashboard/library/'
    | '/_home/blog/$slug/'
    | '/dashboard/goal/$id/'
    | '/dashboard/health-area/$id/'
    | '/_home/blog/page/$pageNumber/'
    | '/dashboard/library/health-area/$slug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  HomeRoute: typeof HomeRouteWithChildren
  ForgotPasswordIndexRoute: typeof ForgotPasswordIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  NewsletterIndexRoute: typeof NewsletterIndexRoute
  RegisterIndexRoute: typeof RegisterIndexRoute
}
export interface FileServerRoutesByFullPath {
  '/api/android-rtdn-webhook': typeof ApiAndroidRtdnWebhookServerRoute
  '/api/health': typeof ApiHealthServerRoute
  '/api/auth/$': typeof ApiAuthSplatServerRoute
}
export interface FileServerRoutesByTo {
  '/api/android-rtdn-webhook': typeof ApiAndroidRtdnWebhookServerRoute
  '/api/health': typeof ApiHealthServerRoute
  '/api/auth/$': typeof ApiAuthSplatServerRoute
}
export interface FileServerRoutesById {
  __root__: typeof rootServerRouteImport
  '/api/android-rtdn-webhook': typeof ApiAndroidRtdnWebhookServerRoute
  '/api/health': typeof ApiHealthServerRoute
  '/api/auth/$': typeof ApiAuthSplatServerRoute
}
export interface FileServerRouteTypes {
  fileServerRoutesByFullPath: FileServerRoutesByFullPath
  fullPaths: '/api/android-rtdn-webhook' | '/api/health' | '/api/auth/$'
  fileServerRoutesByTo: FileServerRoutesByTo
  to: '/api/android-rtdn-webhook' | '/api/health' | '/api/auth/$'
  id: '__root__' | '/api/android-rtdn-webhook' | '/api/health' | '/api/auth/$'
  fileServerRoutesById: FileServerRoutesById
}
export interface RootServerRouteChildren {
  ApiAndroidRtdnWebhookServerRoute: typeof ApiAndroidRtdnWebhookServerRoute
  ApiHealthServerRoute: typeof ApiHealthServerRoute
  ApiAuthSplatServerRoute: typeof ApiAuthSplatServerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_home': {
      id: '/_home'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register/': {
      id: '/register/'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/newsletter/': {
      id: '/newsletter/'
      path: '/newsletter'
      fullPath: '/newsletter'
      preLoaderRoute: typeof NewsletterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgotPassword/': {
      id: '/forgotPassword/'
      path: '/forgotPassword'
      fullPath: '/forgotPassword'
      preLoaderRoute: typeof ForgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_home/': {
      id: '/_home/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof HomeRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/routines': {
      id: '/dashboard/routines'
      path: '/routines'
      fullPath: '/dashboard/routines'
      preLoaderRoute: typeof DashboardRoutinesRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/profile': {
      id: '/dashboard/profile'
      path: '/profile'
      fullPath: '/dashboard/profile'
      preLoaderRoute: typeof DashboardProfileRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/notificationSettings': {
      id: '/dashboard/notificationSettings'
      path: '/notificationSettings'
      fullPath: '/dashboard/notificationSettings'
      preLoaderRoute: typeof DashboardNotificationSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/newUser': {
      id: '/dashboard/newUser'
      path: '/newUser'
      fullPath: '/dashboard/newUser'
      preLoaderRoute: typeof DashboardNewUserRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/health-areas': {
      id: '/dashboard/health-areas'
      path: '/health-areas'
      fullPath: '/dashboard/health-areas'
      preLoaderRoute: typeof DashboardHealthAreasRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/goals': {
      id: '/dashboard/goals'
      path: '/goals'
      fullPath: '/dashboard/goals'
      preLoaderRoute: typeof DashboardGoalsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/calendarSettings': {
      id: '/dashboard/calendarSettings'
      path: '/calendarSettings'
      fullPath: '/dashboard/calendarSettings'
      preLoaderRoute: typeof DashboardCalendarSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/calendar': {
      id: '/dashboard/calendar'
      path: '/calendar'
      fullPath: '/dashboard/calendar'
      preLoaderRoute: typeof DashboardCalendarRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/account': {
      id: '/dashboard/account'
      path: '/account'
      fullPath: '/dashboard/account'
      preLoaderRoute: typeof DashboardAccountRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_home/unsubscribe': {
      id: '/_home/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof HomeUnsubscribeRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/tools': {
      id: '/_home/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof HomeToolsRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/termsOfService': {
      id: '/_home/termsOfService'
      path: '/termsOfService'
      fullPath: '/termsOfService'
      preLoaderRoute: typeof HomeTermsOfServiceRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/resetPassword': {
      id: '/_home/resetPassword'
      path: '/resetPassword'
      fullPath: '/resetPassword'
      preLoaderRoute: typeof HomeResetPasswordRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/privacyPolicy': {
      id: '/_home/privacyPolicy'
      path: '/privacyPolicy'
      fullPath: '/privacyPolicy'
      preLoaderRoute: typeof HomePrivacyPolicyRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/pricing': {
      id: '/_home/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof HomePricingRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/contact': {
      id: '/_home/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof HomeContactRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/compare': {
      id: '/_home/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof HomeCompareRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/colors': {
      id: '/_home/colors'
      path: '/colors'
      fullPath: '/colors'
      preLoaderRoute: typeof HomeColorsRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/changelog': {
      id: '/_home/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof HomeChangelogRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/authError': {
      id: '/_home/authError'
      path: '/authError'
      fullPath: '/authError'
      preLoaderRoute: typeof HomeAuthErrorRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/affiliate': {
      id: '/_home/affiliate'
      path: '/affiliate'
      fullPath: '/affiliate'
      preLoaderRoute: typeof HomeAffiliateRouteImport
      parentRoute: typeof HomeRoute
    }
    '/_home/aboutUs': {
      id: '/_home/aboutUs'
      path: '/aboutUs'
      fullPath: '/aboutUs'
      preLoaderRoute: typeof HomeAboutUsRouteImport
      parentRoute: typeof HomeRoute
    }
    '/dashboard/library/': {
      id: '/dashboard/library/'
      path: '/library'
      fullPath: '/dashboard/library'
      preLoaderRoute: typeof DashboardLibraryIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_home/blog/': {
      id: '/_home/blog/'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof HomeBlogIndexRouteImport
      parentRoute: typeof HomeRoute
    }
    '/dashboard/routine/manage': {
      id: '/dashboard/routine/manage'
      path: '/routine/manage'
      fullPath: '/dashboard/routine/manage'
      preLoaderRoute: typeof DashboardRoutineManageRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/health-area/manage': {
      id: '/dashboard/health-area/manage'
      path: '/health-area/manage'
      fullPath: '/dashboard/health-area/manage'
      preLoaderRoute: typeof DashboardHealthAreaManageRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/goal/manage': {
      id: '/dashboard/goal/manage'
      path: '/goal/manage'
      fullPath: '/dashboard/goal/manage'
      preLoaderRoute: typeof DashboardGoalManageRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/health-area/$id/': {
      id: '/dashboard/health-area/$id/'
      path: '/health-area/$id'
      fullPath: '/dashboard/health-area/$id'
      preLoaderRoute: typeof DashboardHealthAreaIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/goal/$id/': {
      id: '/dashboard/goal/$id/'
      path: '/goal/$id'
      fullPath: '/dashboard/goal/$id'
      preLoaderRoute: typeof DashboardGoalIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_home/blog/$slug/': {
      id: '/_home/blog/$slug/'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof HomeBlogSlugIndexRouteImport
      parentRoute: typeof HomeRoute
    }
    '/dashboard/library/health-area/$slug/': {
      id: '/dashboard/library/health-area/$slug/'
      path: '/library/health-area/$slug'
      fullPath: '/dashboard/library/health-area/$slug'
      preLoaderRoute: typeof DashboardLibraryHealthAreaSlugIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_home/blog/page/$pageNumber/': {
      id: '/_home/blog/page/$pageNumber/'
      path: '/blog/page/$pageNumber'
      fullPath: '/blog/page/$pageNumber'
      preLoaderRoute: typeof HomeBlogPagePageNumberIndexRouteImport
      parentRoute: typeof HomeRoute
    }
  }
}
declare module '@tanstack/react-start/server' {
  interface ServerFileRoutesByPath {
    '/api/health': {
      id: '/api/health'
      path: '/api/health'
      fullPath: '/api/health'
      preLoaderRoute: typeof ApiHealthServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/android-rtdn-webhook': {
      id: '/api/android-rtdn-webhook'
      path: '/api/android-rtdn-webhook'
      fullPath: '/api/android-rtdn-webhook'
      preLoaderRoute: typeof ApiAndroidRtdnWebhookServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/auth/$': {
      id: '/api/auth/$'
      path: '/api/auth/$'
      fullPath: '/api/auth/$'
      preLoaderRoute: typeof ApiAuthSplatServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
  }
}

interface DashboardRouteRouteChildren {
  DashboardAccountRoute: typeof DashboardAccountRoute
  DashboardCalendarRoute: typeof DashboardCalendarRoute
  DashboardCalendarSettingsRoute: typeof DashboardCalendarSettingsRoute
  DashboardGoalsRoute: typeof DashboardGoalsRoute
  DashboardHealthAreasRoute: typeof DashboardHealthAreasRoute
  DashboardNewUserRoute: typeof DashboardNewUserRoute
  DashboardNotificationSettingsRoute: typeof DashboardNotificationSettingsRoute
  DashboardProfileRoute: typeof DashboardProfileRoute
  DashboardRoutinesRoute: typeof DashboardRoutinesRoute
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardGoalManageRoute: typeof DashboardGoalManageRoute
  DashboardHealthAreaManageRoute: typeof DashboardHealthAreaManageRoute
  DashboardRoutineManageRoute: typeof DashboardRoutineManageRoute
  DashboardLibraryIndexRoute: typeof DashboardLibraryIndexRoute
  DashboardGoalIdIndexRoute: typeof DashboardGoalIdIndexRoute
  DashboardHealthAreaIdIndexRoute: typeof DashboardHealthAreaIdIndexRoute
  DashboardLibraryHealthAreaSlugIndexRoute: typeof DashboardLibraryHealthAreaSlugIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardAccountRoute: DashboardAccountRoute,
  DashboardCalendarRoute: DashboardCalendarRoute,
  DashboardCalendarSettingsRoute: DashboardCalendarSettingsRoute,
  DashboardGoalsRoute: DashboardGoalsRoute,
  DashboardHealthAreasRoute: DashboardHealthAreasRoute,
  DashboardNewUserRoute: DashboardNewUserRoute,
  DashboardNotificationSettingsRoute: DashboardNotificationSettingsRoute,
  DashboardProfileRoute: DashboardProfileRoute,
  DashboardRoutinesRoute: DashboardRoutinesRoute,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardGoalManageRoute: DashboardGoalManageRoute,
  DashboardHealthAreaManageRoute: DashboardHealthAreaManageRoute,
  DashboardRoutineManageRoute: DashboardRoutineManageRoute,
  DashboardLibraryIndexRoute: DashboardLibraryIndexRoute,
  DashboardGoalIdIndexRoute: DashboardGoalIdIndexRoute,
  DashboardHealthAreaIdIndexRoute: DashboardHealthAreaIdIndexRoute,
  DashboardLibraryHealthAreaSlugIndexRoute:
    DashboardLibraryHealthAreaSlugIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

interface HomeRouteChildren {
  HomeAboutUsRoute: typeof HomeAboutUsRoute
  HomeAffiliateRoute: typeof HomeAffiliateRoute
  HomeAuthErrorRoute: typeof HomeAuthErrorRoute
  HomeChangelogRoute: typeof HomeChangelogRoute
  HomeColorsRoute: typeof HomeColorsRoute
  HomeCompareRoute: typeof HomeCompareRoute
  HomeContactRoute: typeof HomeContactRoute
  HomePricingRoute: typeof HomePricingRoute
  HomePrivacyPolicyRoute: typeof HomePrivacyPolicyRoute
  HomeResetPasswordRoute: typeof HomeResetPasswordRoute
  HomeTermsOfServiceRoute: typeof HomeTermsOfServiceRoute
  HomeToolsRoute: typeof HomeToolsRoute
  HomeUnsubscribeRoute: typeof HomeUnsubscribeRoute
  HomeIndexRoute: typeof HomeIndexRoute
  HomeBlogIndexRoute: typeof HomeBlogIndexRoute
  HomeBlogSlugIndexRoute: typeof HomeBlogSlugIndexRoute
  HomeBlogPagePageNumberIndexRoute: typeof HomeBlogPagePageNumberIndexRoute
}

const HomeRouteChildren: HomeRouteChildren = {
  HomeAboutUsRoute: HomeAboutUsRoute,
  HomeAffiliateRoute: HomeAffiliateRoute,
  HomeAuthErrorRoute: HomeAuthErrorRoute,
  HomeChangelogRoute: HomeChangelogRoute,
  HomeColorsRoute: HomeColorsRoute,
  HomeCompareRoute: HomeCompareRoute,
  HomeContactRoute: HomeContactRoute,
  HomePricingRoute: HomePricingRoute,
  HomePrivacyPolicyRoute: HomePrivacyPolicyRoute,
  HomeResetPasswordRoute: HomeResetPasswordRoute,
  HomeTermsOfServiceRoute: HomeTermsOfServiceRoute,
  HomeToolsRoute: HomeToolsRoute,
  HomeUnsubscribeRoute: HomeUnsubscribeRoute,
  HomeIndexRoute: HomeIndexRoute,
  HomeBlogIndexRoute: HomeBlogIndexRoute,
  HomeBlogSlugIndexRoute: HomeBlogSlugIndexRoute,
  HomeBlogPagePageNumberIndexRoute: HomeBlogPagePageNumberIndexRoute,
}

const HomeRouteWithChildren = HomeRoute._addFileChildren(HomeRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  HomeRoute: HomeRouteWithChildren,
  ForgotPasswordIndexRoute: ForgotPasswordIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  NewsletterIndexRoute: NewsletterIndexRoute,
  RegisterIndexRoute: RegisterIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
const rootServerRouteChildren: RootServerRouteChildren = {
  ApiAndroidRtdnWebhookServerRoute: ApiAndroidRtdnWebhookServerRoute,
  ApiHealthServerRoute: ApiHealthServerRoute,
  ApiAuthSplatServerRoute: ApiAuthSplatServerRoute,
}
export const serverRouteTree = rootServerRouteImport
  ._addFileChildren(rootServerRouteChildren)
  ._addFileTypes<FileServerRouteTypes>()
